import { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";

import React from "react";
import "./Banner4.css";

import Beatrix_Sellei_psychology_academic from "../CardComponents/Beatrix_Sellei_psychology_academic";
import PreviousCard2 from "../CardComponents/PreviousCard2";
import PreviousCard3 from "../CardComponents/PreviousCard3";
import PreviousCard4 from "../CardComponents/PreviousCard4";
import PreviousCard5 from "../CardComponents/PreviousCard5";
import PreviousCard6 from "../CardComponents/PreviousCard6";
import PreviousCard7 from "../CardComponents/PreviousCard7";
import PreviousCard8 from "../CardComponents/PreviousCard8";
import PreviousCard9 from "../CardComponents/PreviousCard9";
import PreviousCard10 from "../CardComponents/PreviousCard10";
import PreviousCard11 from "../CardComponents/PreviousCard11";
import PreviousCard12 from "../CardComponents/PreviousCard12";
import PreviousCard13 from "../CardComponents/PreviousCard13";
import PreviousCard14 from "../CardComponents/PreviousCard14";
import Card1 from "../CardComponents/Card1";
import Card2 from "../CardComponents/Card2";
import Card3 from "../CardComponents/Card3";
import Card4 from "../CardComponents/Card4";
import Card5 from "../CardComponents/Card5";
import Card6 from "../CardComponents/Card6";
import Card7 from "../CardComponents/Card7";
import Card8 from "../CardComponents/Card8";
import Card2024_1 from "../CardComponents/Card2024_1";
import Card2024_2 from "../CardComponents/Card2024_2";
import Bence_Lestyan_dataviz from "../CardComponents/Bence_Lestyan_dataviz";
import Balint_Kovari_2d_objects from "../CardComponents/Balint_Kovari_2d_object";
import Balazs_Varga_GNN_traffic from "../CardComponents/Balazs_Varga_GNN_traffic";
import Balazs_Varga_design_of_exp from "../CardComponents/Balazs_Varga_design_of_exp";
import Zsombor_Berezvai_bubi from "../CardComponents/Zombor_Berezvai_bubi";
import Orsolya_Vasarhelyi_fairness_of_LLMS from "../CardComponents/Orsolya_Vasarhelyi_fairness_of_LLMS";
import Laszlo_Csato_UEFA_balance from "../CardComponents/Laszlo_Csato_UEFA_balance";
import D_Szemere_and_V_Surman_electric_scooters from "../CardComponents/D_Szemere_and_V_Surman_electric_scooters";
import Balazs_Pejo_contr_eval_federated from "../CardComponents/Balazs_Pejo_contr_eval_federated";
import Gyorgy_Karolyi_decaying_chaos from "../CardComponents/Gyorgy_Karolyi_decaying_chaos";
import Balazs_Lengyel_spatial_waves from "../CardComponents/Balazs_Lengyel_spatial_waves";
import Gergo_Orban_repr_learning from "../CardComponents/Gergo_Orban_repr_learning";
import Gergo_Orban_brain from "../CardComponents/Gergo_Orban_brain";
import Tamas_Ormandi_PCA_V2X from "../CardComponents/Tamas_Ormandi_PCA_V2X";
import T_Tettamanti_waze from "../CardComponents/T_Tettamanti_waze";
import Laszlo_Csato_swiss_system from "../CardComponents/Laszlo_Csato_swiss_system";
import Laszlo_Toka_AI_sport_analytics from "../CardComponents/Laszlo_Toka_AI_sport_analytics";
import Laszlo_Toka_context_aware from "../CardComponents/Laszlo_Toka_context_aware";
import Botond_Szilagyi_mirror_modeling from "../CardComponents/Botond_Szilagyi_mirror_modeling";
import Oliver_Hortay_EU_energy from "../CardComponents/Oliver_Hortay_EU_energy";
import Chris_Stapenhurst_stable_coop from "../CardComponents/Chris_Stapenhurst_stable_coop";
import Chris_Stapenhurst_stoch_coop from "../CardComponents/Chris_Stapenhurst_stoch_coop";
import F_Aslan_and_Ch_Stapenhurst_strat from "../CardComponents/F_Aslan_and_Ch_Stapenhurst_strat";
import Zsolt_Olah_fin_stress_test from "../CardComponents/Zsolt_Olah_fin_stress_test";
import O_Balogh_and_B_Agg_protein from "../CardComponents/O_Balogh_and_B_Agg_protein";
import Bence_Biro_electricity from "../CardComponents/Bence_Biro_electricity";
import Laszlo_Csato_alternative_UEFA from "../CardComponents/Laszlo_Csato_alternative_UEFA";
// 2026 Spring update
import I_G_Kulcsar_digital from "../CardComponents/I_G_Kulcsar_digital";
import Zs_Cserdi_and_A_Torok_invisible from "../CardComponents/Zs_Cserdi_and_A_Torok_invisible";
import Katalin_Varga_macro from "../CardComponents/Katalin_Varga_macro";
import Gabor_Hellner_hybrid_volatility from "../CardComponents/Gabor_Hellner_hybrid_volatility";
import Laszlo_Molnar_videogame from "../CardComponents/Laszlo_Molnar_videogame";
import Petra_Benedek_control_systems from "../CardComponents/Petra_Benedek_control_systems";
import Botond_Szilagyi_pixel from "../CardComponents/Botond_Szilagyi_pixel";
import Tamas_Koltai_DEA from "../CardComponents/Tamas_Koltai_DEA";
import Tamas_Wagner_aperiodic from "../CardComponents/Tamas_Wagner_aperiodic";
import Balazs_Varga_drive_cycle from "../CardComponents/Balazs_Varga_drive_cycle";
import Balazs_Pejo_privacy_federated from "../CardComponents/Balazs_Pejo_privacy_federated";
// 2026 Fall update
import T_Tettamanti_dynamics_modeling from "../CardComponents/T_Tettamanti_dynamics_modeling";
import Andras_Nemeslaki_dynamics from "../CardComponents/Andras_Nemeslaki_dynamics";
import T_Tettamanti_microscopic from "../CardComponents/T_Tettamanti_microscopic";
import Gergo_Orban_spike from "../CardComponents/Gergo_Orban_spike";
import Laszlo_Csato_penalty from "../CardComponents/Laszlo_Csato_penalty";
import I_Miklos_and_J_Gait_pottery from "../CardComponents/I_Miklos_and_J_Gait_pottery";
import I_Miklos_and_Cs_Gedeon_burrow from "../CardComponents/I_Miklos_and_Cs_Gedeon_burrow";
import Istvan_Sajtos_lattices from "../CardComponents/Istvan_Sajtos_lattices";
import M_Nagy_and_S_Marin_mlops from "../CardComponents/M_Nagy_and_S_Marin_mlops";
import V_Surman_and_B_Arki_quality from "../CardComponents/V_Surman_and_B_Arki_quality";
import Adam_Jacso_robotic from "../CardComponents/Adam_Jacso_robotic";
import Gyorgy_Karolyi_double_road_closure from "../CardComponents/Gyorgy_Karolyi_double_road_closure";



export const Banner4 = () => {
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }
  function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(
      getWindowDimensions()
    );
    useEffect(() => {
      function handleResize() {
        setWindowDimensions(getWindowDimensions());
      }

      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);
    return windowDimensions;
  }
  const { height, width } = useWindowDimensions();

  let numberofcards = 3;
  let gSomething = "auto";
  let gSomethingElse = "g-5";
  let cardClass = "Card3";
  // console.log(width);

  if (width < "1200") {
    numberofcards = 2;
    gSomething = "g-3";
    gSomethingElse = "g-4";
    cardClass = "Card2";
  }

  const [isShown, setIsShown] = useState(false);

  
  const ref = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          window.history.pushState({}, "", "#projects");
        }
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.2,
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);


const [ShowMore, setShowMore] = useState(false);

function showMoreButton() {
  setShowMore(!ShowMore);}
  

  return (
    <section className="banner4" id="previous" ref={ref}>
      <Container>          <h1>Previous projects</h1>
       
      </Container>
      <Container className={gSomething}>
        <Row xs={1} md={numberofcards} className={gSomethingElse}>

          <Col>
            <Adam_Jacso_robotic/>
          </Col>
          <Col>
            <V_Surman_and_B_Arki_quality/>
          </Col>
          <Col>
            <M_Nagy_and_S_Marin_mlops/>
          </Col>

          </Row>
          </Container>
<br/><br/>

            { ShowMore && ( <><Container className={gSomething}>
        <Row xs={1} md={numberofcards} className={gSomethingElse}>

          <Col>
            <Istvan_Sajtos_lattices/>
          </Col>
          <Col>
            <I_Miklos_and_Cs_Gedeon_burrow/>
          </Col>
          <Col>
            <I_Miklos_and_J_Gait_pottery/>
          </Col>
          <Col>
            <Laszlo_Csato_penalty/>
          </Col>
          <Col>
            <Gergo_Orban_spike/>
          </Col>
          <Col>
            <T_Tettamanti_microscopic/>
          </Col>
          <Col>
            <Andras_Nemeslaki_dynamics/>
          </Col>
          <Col> 
            <T_Tettamanti_dynamics_modeling/>
          </Col>
          <Col>
            <Gyorgy_Karolyi_double_road_closure/>
          </Col>
          <Col> 
            <Bence_Biro_electricity/>
          </Col>
          <Col>
            <Laszlo_Csato_alternative_UEFA/>
          </Col>
          <Col>
           <Card4/>
          </Col>
          <Col>
            <Balazs_Pejo_privacy_federated/>
          </Col>
          <Col> 
            <Balazs_Varga_drive_cycle/>
          </Col>
          <Col> 
            <Tamas_Wagner_aperiodic/>
          </Col>
          <Col> 
            <Tamas_Koltai_DEA/>
          </Col>
          <Col>
            <Botond_Szilagyi_pixel/>
          </Col>
          <Col>
            <Petra_Benedek_control_systems/>
          </Col>
          <Col>
            <Laszlo_Molnar_videogame/>
          </Col>
          <Col>
            <Gabor_Hellner_hybrid_volatility/>
          </Col>
          <Col>
            <Katalin_Varga_macro/>
          </Col>
          <Col>
            <Zs_Cserdi_and_A_Torok_invisible/>
          </Col>
          <Col>
            <I_G_Kulcsar_digital/>
          </Col>
          <Col> 
           <F_Aslan_and_Ch_Stapenhurst_strat/>
          </Col>
          <Col> 
           <Zsolt_Olah_fin_stress_test/>
          </Col>
          <Col> 
            <O_Balogh_and_B_Agg_protein/>
          </Col>
          <Col>
            <Card1/>
          </Col>
          <Col>
           <Card2/>
          </Col>
          <Col>
           <Card3/>
          </Col>
          
          <Col> 
           <Chris_Stapenhurst_stoch_coop/>
          </Col>
          <Col> 
           <Chris_Stapenhurst_stable_coop/>
          </Col>
          <Col> 
           <Oliver_Hortay_EU_energy/>
          </Col>
          <Col> 
           <Botond_Szilagyi_mirror_modeling/>
          </Col>
          <Col> 
           <Laszlo_Toka_context_aware/>
          </Col>
          <Col> 
           <Laszlo_Toka_AI_sport_analytics/>
          </Col>
          <Col> 
           <Laszlo_Csato_swiss_system/>
          </Col>
          <Col> 
           <T_Tettamanti_waze/>
          </Col>
          <Col> 
           <Tamas_Ormandi_PCA_V2X/>
          </Col>
          <Col> 
           <Gergo_Orban_brain/>
          </Col>
          <Col> 
           <Gergo_Orban_repr_learning/>
          </Col>
          <Col> 
           <Balazs_Lengyel_spatial_waves/>
          </Col>
          <Col> 
           <Gyorgy_Karolyi_decaying_chaos/>
          </Col>
          <Col> 
           <Balazs_Pejo_contr_eval_federated/>
          </Col>
          <Col> 
           <D_Szemere_and_V_Surman_electric_scooters/>
          </Col>
          <Col> 
           <Laszlo_Csato_UEFA_balance/>
          </Col>
          <Col> 
           <Orsolya_Vasarhelyi_fairness_of_LLMS/>
          </Col>
          
          <Col>
           <Balazs_Varga_design_of_exp/>
          </Col>
          <Col>
           <Balazs_Varga_GNN_traffic/>
          </Col>
          <Col>
           <Balint_Kovari_2d_objects/>
          </Col>
          <Col>
           <Bence_Lestyan_dataviz/>
          </Col>
          
          <Col>
          <Card5/>
          </Col>
          <Col>
           <Card6/>
          </Col>
          <Col>
           <Card7/>
          </Col>
          <Col>
            <Card8/>
          </Col>
          <Col>
            <PreviousCard2/>
          </Col>
          <Col>
           <PreviousCard3/>
          </Col>
          <Col>
           <PreviousCard4/>
          </Col>
          <Col>
            <PreviousCard5/>
          </Col>
          <Col>
           <PreviousCard6/>
          </Col>
          <Col>
          <PreviousCard7/>

          </Col>
          <Col>
          <PreviousCard8/>

          </Col>
          <Col>
          <PreviousCard9/>

          </Col>
          <Col>
          <PreviousCard10/>

          </Col>
          <Col>
          <PreviousCard11/>
          </Col>
          <Col>
           <PreviousCard12/>
          </Col>
          <Col>
          <PreviousCard13/>
        </Col>
          
        </Row>
      </Container>
      
      <Container className="g-3">
        <Row xs={1} md={2} className="g-4">
        <Col>
          <PreviousCard14/>
        </Col>
          
        </Row>
      </Container></>)} 
      <div className="ShowMoreButton">
      <Button className="button" onClick={showMoreButton}>{ShowMore?"Show Less" : "Show More"}</Button></div>
    </section>
  );
};
